{{#if isPipelinedWrite}}
virtual task wait_for_resp();
  {{ respEvtVariable.identifier }}.wait_ptrigger();
endtask
{{/if}}
